import React from 'react';

import './BigButton.scss';

interface BigButtonProps {
  name: string;
  type: 'light' | 'dark';
  disabled?: boolean;
  size?: 'tiny' | 'small' | 'medium';
  onClick?: any;
  className?: string;
}

export function BigButton(props: BigButtonProps) {
  return (
    <div
      onClick={!props.disabled ? props.onClick : () => false}
      className={`big-button ${props.type} ${props.size ? props.size : 'medium'} ${
        props.disabled ? 'disabled' : ''
      } ${props.className ? props.className : ''}`}
    >
      {props.name}
    </div>
  );
}
